import Vue from 'vue'
import VueRouter from 'vue-router'
import InitialPage from '../Pages/InitialPage.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'InitialPage',
        component: InitialPage
    },
    {
        path: "/BasicSettings",
        name: "BasicSettings",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/BaseSettings.vue")
    },
    {
        path: "/Dashboard",
        name: "Dashboard",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/Dashboard.vue")
    },
    {
        path: "/login",
        name: "login",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/login.vue")
    },
    {
        path: "/Voucher",
        name: "Voucher",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/Voucher.vue")
    },
    {
        path: "/Pdtscan",
        name: "PdtScan",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/Pdtscan.vue")
    },

    {
        path: "/BarcodeResult",
        name: "BarcodeResult",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/Barcoderesult.vue")
    },
    {
        path: "/Printbarcode",
        name: "Printbarcode",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/PrintBarcode.vue")
    },
    {
        path: "/Sales",
        name: "Sales",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/Sales.vue")
    },
    {
        path: "/SalesAll",
        name: "SalesAll",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/SalesAll.vue")
    },
    
    {
        path: "/Preference",
        name: "Preference",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/Preference.vue")
    },
    {
        path: "/BranchwiseSales",
        name: "BranchwiseSales",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/BranchwiseSales.vue")
    },
    {
        path: "/VoucherRegister",
        name: "VoucherRegister",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Register/VoucherRegister.vue")
    },
       {
        path: "/VerifyVoucher",
        name: "VerifyVoucher",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/VerifyVoucher.vue")
    },
     {
        path: "/VoucherVerification",
        name: "VoucherVerification",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../Pages/VoucherVerification.vue")
    },
]

const router = new VueRouter({
    routes
})

export default router